"use strict";

let dropdownInited = false;

export class searchHelper {

    static getSearchAndFilterContent(url, pushState = true) {
        $.ajax({
            url: url,
            async: false,
            cache: false,
        })
            .done(function (data) {
                $('#search-page-filter-and-content').html(data.html);
                if (pushState) {
                    searchHelper.pushHistoryState(url);
                }

                searchHelper.initAll();
            })
    }

    static getPrettyUrl(url) {
        let prettyUrl = '';

        $.ajax({
            url: url + searchHelper.getPrettyUrlMark(),
            async: false,
            cache: false,
            success: function (data) {
                prettyUrl = data.url;
            }
        });

        return prettyUrl;
    }

    static initAll() {
        searchHelper.drawQuickFilterLabels();
        searchHelper.dropdownInit();
        searchHelper.sortableInit();

        if ($(document).find('#slider-range').length > 0) {
            searchHelper.priceRangeInit();
        }
    }

    static dropdownInit() {

        if (false === dropdownInited) {
            dropdownInited = true;

            $(document).on('click', '.input', function () {

                if ($(this).find('.pseudo-select').css('display') == 'none') {
                    $('.dropdown-icon').removeClass('active');
                    $('.pseudo-select').css('display', 'none');
                    $(this).find('.pseudo-select').css('display', 'block');
                    $(this).find('.dropdown-icon').toggleClass('active');

                } else {
                    $(this).find('.dropdown-icon').toggleClass('active');
                    $(this).find('.pseudo-select').css('display', 'none');
                }
            });

            $(document).mouseup(function (e) {
                let div = $('.input');
                if (!div.is(e.target)
                    && div.has(e.target).length === 0) {
                    $('.pseudo-select').css('display', 'none');
                    $('.input').find('.dropdown-icon').removeClass('active');
                }
            });
        }
    }

    static drawQuickFilterLabels() {
        let quickFiltersArr = $(document).find('.quickFilterClass');
        let quickJobFilters = $(document).find('.quickFilterClassJob');
        let quickRangeFilters = $(document).find('.quickFilterRangeClass');

        $.each(quickFiltersArr, function () {
            searchHelper.addQuickFilter($(this).attr('data-type'), $(this).attr('data-id'), $(this).attr('data-name'));
        });

        $('ul.industry-list-ul li.job-li-item input:checked').each(function (k, v) {
            searchHelper.expandSubIndustriesDropdown($(v));
        });

        $('ul.industry-list-ul input.industry-filter-checkbox:checked').each(function (k, v) {
            searchHelper.expandSubIndustriesDropdown($(v));
        });

        $.each(quickRangeFilters, function () {
            searchHelper.addQuickFilter(
                $(this).attr('data-type'),
                $(this).attr('data-id'),
                $(this).attr('data-name'),
                'range'
            );
        });

        if (quickFiltersArr.length > 0 || quickJobFilters.length > 0 || quickRangeFilters.length > 0) {
            $(document).find('.selected-filter-item').append(
                '<div class="btn inverse-btn selected-item clear-filter">'
                + $('.selected-filter-item').attr('data-clear-filter-text') + '</div>');
        }
    }

    static expandSubIndustriesDropdown(el) {
        let parentLi = el.parents('li');
        parentLi.find('div.arrow-wrap img').addClass('active');
        parentLi.find('ul.second-level').addClass('active');
    }

    static addQuickFilter(type, id, name, addClass = '') {
        $(document).find('.selected-filter-item').append(
            '<div class="btn inverse-btn selected-item" data-filter-type="' + type + '" data-id="' + id + '">' + name +
            '<button class="close selected-filter ' + addClass + '">' +
            '</button>' +
            '</div>'
        );
    }

    static sortableInit() {
        let self = this;
        $(document).find('li.sortable').on('click', function () {

            //push all query params to object
            let queryParams = (document.location.search)
                .replace(/(^\?)/, '')
                .split("&")
                .map(function (n) {
                    return n = n.split("="), this[n[0]] = n[1], this
                }.bind({}))[0];

            //always remove sort and direction from object
            $.each(queryParams, function (k, v) {
                if (k === 'direction' || k === 'sort') {
                    delete queryParams['direction'];
                    delete queryParams['sort'];
                }
            });

            let paramsStr = $.param(queryParams) === '=' ? '' : $.param(queryParams);

            //start sign of sorting
            let sign = '?';
            if (paramsStr.indexOf(sign) !== -1 || paramsStr !== '') {
                sign = '&';
            }

            paramsStr = paramsStr !== '' ? '?' + paramsStr : paramsStr;
            self.getSearchAndFilterContent(window.location.pathname + paramsStr + sign + $(this).attr('data-sort'));
        });
    }

    static priceRangeInit() {
        $(function () {
            $(document).find('#slider-range').slider({
                range: true,
                min: parseInt($(document).find('#min_price_hidden').val()),
                max: parseInt($(document).find('#max_price_hidden').val()),
                values: [parseInt($(document).find('#min_price').val()), parseInt($(document).find('#max_price').val())],
                slide: function (event, ui) {
                    $(document).find('.min_price').val(ui.values[0]);
                    $(document).find('.max_price').val(ui.values[1]);
                },
                stop: function (event, ui) {
                    if (0 === ui.handleIndex) { //left slider
                        $(document).find('.min_price').trigger('change');
                    } else if (1 === ui.handleIndex) { //right slider
                        $(document).find('.max_price').trigger('change');
                    }
                }
            });

            $(document).find('.min_price').val($('#slider-range').slider('values', 0));
            $(document).find('.max_price').val($('#slider-range').slider('values', 1));
        });
    }

    static pushHistoryState(url = null) {
        window.history.pushState({
            'html': $('#search-page-filter-and-content').html(),
            'pageTitle': ''
        }, '', url === null ? window.location : url);
    }

    static getPrettyUrlMark() {
        return '&get_pretty_url=1';
    }
}
